<template>
  <div class="comment" ref="comment">
    <div class="comment-textarea">
      <div class="commenttop">
        <div class="headpicbox">
          <img class="imgtop" :src="userImg" alt="">
        </div>
        <div class="textarea_div">
          <div class="textareaInput" id="textareaInput" contenteditable="true" aria-label="输入评论..." @input="changeComment('')"></div>
          <div class="textfun clearfix">
            <!-- <el-popover
              ref="popover"
              placement="top-start"
              :width="popoverWidth"
              trigger="click">
              <ul class="emojiul">
                <li v-for="(item, index) in emojiArr" :key="index" @click="selectEmoji(item, '')">
                  <img :src="item.url" :alt="item.title">
                </li>
              </ul>
              <span class="fl" slot="reference">
                <img :src="Initialemoji" alt="">
              </span>
            </el-popover> -->
            <el-button class="fr" type="primary" round @click="addComment(-1)"><i class="el-icon-edit"></i>评论</el-button>
          </div>
        </div>
      </div>
      <h2 class="textareatitle" v-if="commentList && commentList.length > 0">全部评论</h2>
      <ul class="textarea_list" v-if="commentList && commentList.length > 0">
        <li v-for="(items, index) in commentList" :key="index">
          <div class="avator">
            <a>
              <img class="imgtop" :src="getUserImg(items.image)" alt="">
            </a>
          </div>
          <div class="conbox">
            <div class="txt">
              <span>{{ items.name }}</span>
              <div class="content" v-html="items.content"></div>
            </div>
            <div class="fun clearfix">
              <p class="fl">{{ setTimeformat(items.crtTime) }}</p>
              <div class="funbox-1 clearfix fr">
<!--                <div class="fl" @click="zanfun"><i class="icon-zan1 fl" ></i><span>36</span></div>-->
                <div class="fl reply" @click="showTextarea(items)"><i></i><span>{{ items.hide ? '收起回复' : '回复'}}</span></div>
              </div>
            </div>
            <div class="textareaBox" v-if="items.hide">
              <div class="textarea_div">
                <div class="textareaInput" :id="'textareaInput'+ index" contenteditable="true" :aria-label="'回复' + setStar(items.mobilePhone, 3, 4)" @input="changeComment(index)"></div>
                <div class="textfun clearfix">
                  <el-popover
                    ref="popover"
                    placement="top-start"
                    :width="popoverWidth"
                    trigger="click">
                    <ul class="emojiul">
                      <li v-for="(item, index1) in emojiArr" :key="index1" @click="selectEmoji(item, index)">
                        <img :src="item.url" :alt="item.title">
                      </li>
                    </ul>
                    <span class="fl" slot="reference">
              <img :src="Initialemoji" alt="">
            </span>
                  </el-popover>
                  <el-button class="fr" type="primary" round @click="addComment(items.id)"><i class="el-icon-edit"></i>评论</el-button>
                </div>
              </div>
            </div>
          </div>
          <ul v-if="items.children && items.children.length > 0">
            <li v-for="(item, index) in items.children" :key="index">
              <div class="avator">
                <a>
                  <img class="imgtop" :src="getUserImg(item.image)" alt="">
                </a>
              </div>
              <div class="conbox">
                <div class="txt">
                  <span>{{ setStar(item.mobilePhone, 3, 4) }}</span>
                  <div class="content" v-html="item.content"></div>
                </div>
                <div class="fun clearfix">
                  <p class="fl">{{ setTimeformat(item.crtTime) }}</p>
                  <div class="funbox-1 clearfix fr">
                    <!--<div class="fl" @click="zanfun"><i class="icon-zan1 fl" ></i><span>36</span></div>-->
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
      <h2 class="loadmore pt30" :class="{ cursorp: moreCommentDesc }" v-if="loadMore" @click="loadMoreComment">{{ moreCommentDesc === true ? '查看更多评论' : '已显示全部评论' }}</h2>
      <h2 class="nodata pt30" v-if="noData">暂无数据</h2>
    </div>

  </div>
</template>

<script>
import { timeFormat } from '@/utils/validate'
import emoji from '@/assets/common/emoji/emoji.json'
import { getComment, addComment } from '@/api/comment/index'
export default {
  name: 'index',
  data () {
    return {
      Initialemoji: '',
      emojiArr: [],
      textareaCon: '',
      popoverWidth: 374,
      userImg: require('@/assets/common/icon/icon-default-avatar.png'),
      baseParam: {
        'fid': this.$cookie.get('culturalCloud_fid'),
        'dataId': this.$route.query.id,
        'page': 1,
        'limit': 10
      },
      commentList: [],
      commentTotal: '',
      iscommentImport: false,
      commentParam: {
        'content': '',
        'memberId': this.$cookie.get('wlyuserid'),
        'fid': this.$cookie.get('culturalCloud_fid'),
        'dataTitle': '',
        'dataMenuId': this.$route.query.columnId,
        'dataId': this.$route.query.id,
        'parentId': -1
      },
      isShow: '',
      noData: false,
      loadMore: false,
      moreCommentDesc: true,
      timer: null // 定时器
    }
  },
  created () {
    const that = this
    that.timer = setInterval(function () {
      if (document.readyState === 'complete') {
        that.$emit('coffsettop', that.$refs.comment.getBoundingClientRect().top)
        window.clearInterval(that.timer)
      }
    }, 1000)
  },
  mounted () {
    // 初始化表情包
    this.emojiInit()
    this.getComment()
  },
  methods: {
    /* 带星星 */
    setStar (name, front, after) {
      return name.substring(0, front) + '*'.repeat(name.length - (front + after)) + name.substring(name.length - after)
    },
    /* 获取头像 */
    getUserImg (val) {
      if (val !== undefined) {
        return val
      } else {
        return require('@/assets/common/icon/icon-default-avatar.png')
      }
    },
    /* 是否登录 */
    isLogin (val) {
      this.$confirm(val, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/login', query: {redirect: this.$router.currentRoute.fullPath}})
      }).catch(() => { })
    },
    /* 时间格式化 */
    setTimeformat (val) {
      return timeFormat(val, 'yymmdd')
    },
    /* 获取评论 */
    getComment () {
      if (this.$cookie.get('wlyuserimg') !== null && this.$cookie.get('wlyuserimg') !== '' && this.$cookie.get('wlyuserimg') !== 'undefined') this.userImg = this.$cookie.get('wlyuserimg')
      getComment(this.baseParam).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data.total > 0) {
            this.noData = false
            this.commentTotal = res.data.data.total
            this.$emit('commentcount', this.commentTotal)
            if (res.data.data.rows.length === this.baseParam.limit) this.loadMore = true
            for (let i in res.data.data.rows) {
              res.data.data.rows[i].hide = false
            }
            if (this.baseParam.page === 1) {
              this.commentList = res.data.data.rows
            } else {
              this.commentList = this.commentList.concat(res.data.data.rows)
              if (res.data.data.rows.length < this.baseParam.limit) this.moreCommentDesc = false
            }
          } else {
            this.noData = true
            this.$emit('commentcount', 0)
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    /* 查看更多评论 */
    loadMoreComment () {
      let commentPageTotal = Math.ceil(this.commentTotal / this.baseParam.limit)
      if (this.baseParam.page < commentPageTotal) {
        this.baseParam.page++
        this.getComment()
      }
    },
    /* 表情初始化 */
    emojiInit () {
      let emoji0 = emoji[0].url
      this.Initialemoji = require('@/assets/common/emoji/' + emoji0)
      for (let i = 0; i < emoji.length; i++) {
        let emojiUrl = emoji[i].url
        let emojiobj = {
          'title': emoji[i].title,
          'url': require('@/assets/common/emoji/' + emojiUrl)
        }
        this.emojiArr.push(emojiobj)
      }
    },
    // 选择表情
    selectEmoji (val, index) {
      const str = "<img style='' src='" + val.url + "'>"
      let ele = document.querySelector('#textareaInput' + index)
      ele.innerHTML = ele.innerHTML + str
      this.$refs.popover.showPopper = false
    },
    // 点赞
    // zanfun (val) {
    //   this.$emit('zan', val)
    // },
    /* 列表 评论是否显示隐藏 */
    showTextarea (items) {
      items.hide = !items.hide
    },
    /* 聚焦评论 */
    changeComment (val) {
      this.commentParam.content = document.querySelector('#textareaInput' + val).innerHTML
      console.log(this.commentParam.content)
    },
    /* 提交评论 */
    addComment (id) {
      if (id !== -1) this.commentParam.parentId = id
      if (this.$cookie.get('wlyuserid') === null) {
        this.isLogin('请登录后评论')
      } else {
        if (this.commentParam.content === '') {
          this.$message.error('评论不能为空')
          return
        }
        if (this.$parent.infordetail !== undefined) this.commentParam.dataTitle = this.$parent.infordetail.title
        if (this.$parent.detail !== undefined) {
          if (this.$parent.detail.title !== undefined) this.commentParam.dataTitle = this.$parent.detail.title
          if (this.$parent.detail.name !== undefined) this.commentParam.dataTitle = this.$parent.detail.name
          if (this.$parent.detail.videoName !== undefined) this.commentParam.dataTitle = this.$parent.detail.videoName
          if (this.$parent.detail.bookImage !== undefined) this.commentParam.dataTitle = this.$parent.detail.bookImage
        }
        if (this.$parent.detailInfo !== undefined) {
          if (this.$parent.detailInfo.name !== undefined) this.commentParam.dataTitle = this.$parent.detailInfo.name
          if (this.$parent.detailInfo.declareName !== undefined) this.commentParam.dataTitle = this.$parent.detailInfo.declareName
          if (this.$parent.detailInfo.title !== undefined) this.commentParam.dataTitle = this.$parent.detailInfo.title
        }
        if (this.$parent.appointmentdetail !== undefined) this.commentParam.dataTitle = this.$parent.appointmentdetail.name
        if (this.$parent.detailInfos !== undefined) this.commentParam.dataTitle = this.$parent.detailInfos.name
        if (this.$parent.detailparams !== undefined) this.commentParam.dataTitle = this.$parent.detailparams.name
        if (this.$parent.pavilion !== undefined) this.commentParam.dataTitle = this.$parent.pavilion.title
        if (this.$parent.scenicspotdetail !== undefined) this.commentParam.dataTitle = this.$parent.scenicspotdetail.keyWord
        if (this.$parent.marketdetail !== undefined) this.commentParam.dataTitle = this.$parent.marketdetail.title
        if (this.$parent.params !== undefined) this.commentParam.dataTitle = this.$parent.params.activityName
        addComment(JSON.stringify(this.commentParam)).then((res) => {
          if (res.data.status === 200) {
            this.$message({
              message: '评论成功， 请等待后台审核',
              type: 'success',
              duration: 2000
            })
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.comment{
  padding: 20px;
  margin: 50px 0;
  .comment-textarea{
    position: relative;
    .textarea_div{
      background: #fff;
      border-radius: 6px;
      .textareaInput{
        padding: 20px;
        height: 100px;
        width: 100%;
        color: #666;
        overflow-y: auto;
        &:empty:before {
          content: attr(aria-label);
          color: #666;
        }
      }
      .textfun{
        border-top: solid 1px #f2f2f2;
        padding: 10px 20px;
        .el-button{
          padding: 8px 20px;
          i{
            margin: 0 8px 0 0;
          }
        }
        span{
          margin: 4px 0 0;
          font-size: 18px;
          cursor: pointer;
        }
      }
    }
    .commenttop{
      background: #fafbfc;
      border-radius: 4px;
      padding: 15px 15px 15px 70px;
      .headpicbox{
        position: absolute;
        width: 40px;
        height: 40px;
        top: 15px;
        left: 22px;
        border-radius: 25px;
        overflow: hidden;
      }
    }
    .textareatitle{
      font-size: 18px;
      margin: 40px 0 0;
      font-weight: bold;
    }
    .textarea_list{
      padding-left: 46px;
      margin: 20px 0 20px;
      li{
        position: relative;
        padding: 14px 0px 12px 0;
        margin: 10px 0 0;
        border-bottom: 1px solid #f1f1f1;
        .avator{
          position: absolute;
          width: 36px;
          height: 36px;
          top: 12px;
          left: -46px;
          border-radius: 18px;
          overflow: hidden;
        }
        .conbox{
          .txt{
            .content{
              margin: 4px 0 0;
            }
          }
          .fun{
            line-height: 32px;
            span, p{
              color: #8a9aa9;
            }
            .funbox-1{
              margin: 0;
              .reply{
                cursor: pointer;
              }
            }
          }
          .textareaBox{
            padding: 15px;
            border-radius: 4px;
            background: #fafbfc;
          }
        }
        ul{
          margin: 6px 0 0;
          background: #fafbfc;
          border-radius: 4px;
          li{
            border-bottom: none;
            .avator{
              left: 12px;
            }
            .conbox{
              margin: 0 0 0 58px;
            }
          }
        }
      }
    }
  }
}
.emojiul{
  li{
    float: left;
    width: 30px;
    height: 30px;
    padding: 4px 2px;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    cursor: pointer;
    border: 1px solid #e8e8e8;
    margin: -1px 0 0 -1px;
    &:hover{
      border-color: #eb7350;
      position: relative;
      z-index: 2;
    }
  }
}
@media only screen and (max-width: 768px){
  .comment{
    margin: 30px 0;
    padding: 15px;
    .comment-textarea{
      .headpicbox{
        width: 26px;
        height: 26px;
      }
      .textarea_div{
        margin: 0 0 0 36px;
      }
      .textarea_list{
        padding-left: 36px;
        li{
          .avator{
            width: 26px;
            height: 26px;
          }
          .conbox{
            margin: 0 0 0 36px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comment/index.vue